import { useMemo } from 'react';
import Priority from 'common/components/priority';
import { getTranslatedItems } from 'features/queue/gridFilters/Status/utils';
import { useRbTexts } from 'remote-state/applicationHooks';
import useShowNoEditPermissionPopup from '../../../common/utils/hooks/useShowNoEditPermissionPopup';
import useShowSelectMainCategoryPopup from '../../../common/utils/hooks/useShowSelectMainCategoryPopup';
import Categories from '../categories';
import { itemClassNames } from '../../../common/components/dropdownSelect';

function HeaderTags(props) {
  const {
    srType,
    handleSaveValue,
    categoryRequired,
    priorityRequired,
    priority,
    priorityList,
    dataset,
    headerFields,
    isTemplatePage = false,
    isPriorityDisabled,
    isCategoryDisabled,
    handleDirty,
    onFocus,
    dataTestid = 'priority',
    className = '',
    updateFieldValidation,
    categoriesValues,
    forceSrId = null,
    updateOnExit,
    onTemplateChanged,
    isNewSR = false,
    isCategoryDisabledToEdit = false,
  } = props;

  const { showNoPermissionPopup } = useShowNoEditPermissionPopup();
  const { showSelectMainCategoryPopup } = useShowSelectMainCategoryPopup();

  const handleSave = (e) => {
    handleSaveValue(e);
    updateOnExit?.(true);
  };
  const texts = useRbTexts();
  const normalizedPriorityList = useMemo(
    () => getTranslatedItems(texts, priorityList, itemClassNames.priority),
    [priorityList, texts],
  );

  const showCategoryPopup = useMemo(() => {
    if (isCategoryDisabledToEdit) {
      return showNoPermissionPopup;
    }

    return showSelectMainCategoryPopup;
  }, [isCategoryDisabledToEdit, showSelectMainCategoryPopup, showNoPermissionPopup]);

  return (
    <div className={`header-footer-div ${className}`}>
      <Priority
        className={className}
        dataTestid={dataTestid}
        priority={priority}
        disabled={isPriorityDisabled}
        onDisabledClick={showNoPermissionPopup}
        onFocus={onFocus}
        onChange={handleSave}
        priorityList={normalizedPriorityList}
        required={priorityRequired}
        dataset={dataset}
        fieldId={headerFields?.find((field) => field.fieldName === 'priority')?.fieldId}
        handleDirty={handleDirty}
        headerFields={headerFields}
        isTemplatePage={isTemplatePage}
        updateFieldValidation={updateFieldValidation}
      />
      <Categories
        className={className}
        disabled={isCategoryDisabled}
        onDisabledClick={showCategoryPopup}
        required={categoryRequired}
        dataset={dataset}
        headerFields={headerFields}
        srType={srType}
        handleDirty={handleDirty}
        isTemplatePage={isTemplatePage}
        onFocus={onFocus}
        handleSaveValue={handleSave}
        updateFieldValidation={updateFieldValidation}
        categoriesValues={categoriesValues}
        forceSrId={forceSrId}
        onTemplateChanged={onTemplateChanged}
        isNewSR={isNewSR}
      />
    </div>
  );
}
export default HeaderTags;
